<template>
  <vs-row class="bg-white shadow py-5 px-3 mb-4">
    <vs-col vs-lg="12">
      <div class="d-block">
        <div style="text-align: right; margin-bottom: 5px;">
          <span>
            <feather-icon icon="InboxIcon" class="mr-1" />
            Bandeja de entrada
          </span>
          <span v-if="rangeSelected.valor !== 'personalizado'">
            {{ rangeSelected.nombre }}
          </span>
          <span v-if="rangeSelected.valor === 'personalizado'">
            entre el
            <datetime
              v-model="rangeFrom"
              input-class="form-control input-date"
              :phrases="{ ok: 'Seleccionar', cancel: 'Cancelar' }"
              value-zone="local"
              format="yyyy-MM-dd"
              data-cy="start-time"
            />
            y el
            <datetime
              v-model="rangeUntil"
              input-class="form-control input-date"
              :phrases="{ ok: 'Seleccionar', cancel: 'Cancelar' }"
              value-zone="local"
              format="yyyy-MM-dd"
              data-cy="end-time"
            />
            <span>
              <vs-button
                radius
                class="ml-3 d-inline"
                color="primary"
                type="border"
                icon="search"
                size="small"
                @click="applyFilters()"
              />
            </span>
          </span>
          <vs-dropdown vs-trigger-click style="margin-left: 15px">
            <a class="a-icon" href="#">
              Cambiar
              <vs-icon icon="expand_more" />
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item
                style="width: 200px"
                v-for="range in ranges"
                :key="range.valor"
                v-on:click.native="selectRange(range)"
              >
                {{ range.nombre }}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
    </vs-col>
    <vs-col vs-lg="1">
      <b-button
        v-tooltip="'Buscar'"
        variant="primary"
        class="btn-icon rounded-circle p-3"
        size="sm"
        v-on:click="applyFilters()"
      >
        <feather-icon icon="SearchIcon" />
      </b-button>
    </vs-col>
    <vs-col vs-lg="9">
      <input
        v-model="searchText"
        placeholder="Buscar por asunto o nombre de adjunto..."
        class="form-control"
        data-cy="search-received"
        v-on:keypress.enter="applyFilters"
      />
    </vs-col>
    <vs-col vs-lg="2">
      <b-button
        :variant="sortOrder === 'desc' ? 'outline-primary' : 'outline-secondary'"
        size="sm"
        class="w-100"
        @click="toggleSort"
      >
        <feather-icon :icon="sortOrder === 'desc' ? 'ArrowDownIcon' : 'ArrowUpIcon'" size="14" class="mr-1" />
        {{ sortOrder === 'desc' ? 'Más recientes' : 'Más antiguos' }}
      </b-button>
    </vs-col>
  </vs-row>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import { DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';

export default {
  name: 'ReceivedEmailsFilter',
  mixins: [SelectorDateMixin],
  data() {
    return {
      ranges: DATE_RANGES,
      rangeSelected: { nombre: 'los últimos 6 meses', valor: 'ultimos6meses' },
      rangeFrom: '',
      rangeUntil: '',
      searchText: '',
      sortOrder: 'desc'
    };
  },
  computed: {
    ...mapGetters('ReceivedEmails', ['page', 'itemsPerPage']),
    queryFilters() {
      const filters = [];

      if (this.searchText) {
        filters.push({
          bool: {
            should: [
              {
                match_phrase_prefix: {
                  subject: {
                    query: this.searchText
                  }
                }
              },
              {
                match_phrase_prefix: {
                  'attachments.name': {
                    query: this.searchText
                  }
                }
              }
            ],
            minimum_should_match: 1
          }
        });
      }

      if (this.rangeFrom && this.rangeUntil) {
        const from = this.rangeSelected.valor === 'personalizado'
          ? this.rangeFrom.split('T')[0]
          : this.rangeFrom;
        const to = this.rangeSelected.valor === 'personalizado'
          ? this.rangeUntil.split('T')[0]
          : this.rangeUntil;

        filters.push({
          range: {
            timestamp: {
              from,
              to,
              include_lower: true,
              include_upper: true,
              boost: 1
            }
          }
        });
      }

      return {
        bool: {
          filter: filters,
          adjust_pure_negative: true,
          boost: 1.0
        }
      };
    }
  },
  watch: {
    page() {
      this.debounceFetchData();
    },
    itemsPerPage() {
      this.debounceFetchData();
    }
  },
  methods: {
    ...mapActions('ReceivedEmails', ['getReceivedEmailsList', 'movePage']),
    debounceFetchData: _.debounce(async function debounceFetchData() {
      await this.getReceivedEmailsList({
        query: this.queryFilters,
        sort: [{ timestamp: { order: this.sortOrder, missing: '_last' } }],
        page: this.page,
        itemsPerPage: this.itemsPerPage
      });
    }, 100),
    applyFilters() {
      this.movePage(1);
      this.debounceFetchData();
    },
    toggleSort() {
      this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc';
      this.applyFilters();
    }
  },
  mounted() {
    this.selectRange(this.rangeSelected, true);
    this.debounceFetchData();
  }
};
</script>
